"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultRemoveFromWishlistCommandHandler = void 0;
const domain_1 = require("../../domain");
const favourite_invalid_study_id_1 = require("../../domain/exceptions/favourite-invalid-study-id");
const base_wishlist_command_handler_1 = require("../base-wishlist-command-handler");
class DefaultRemoveFromWishlistCommandHandler extends base_wishlist_command_handler_1.BaseWishlistCommandHandler {
    constructor(wishlistRepository, eventEmitter) {
        super(wishlistRepository);
        this.wishlistRepository = wishlistRepository;
        this.eventEmitter = eventEmitter;
    }
    validate(command) {
        if (typeof command.studyId !== 'number') {
            throw new favourite_invalid_study_id_1.FavouriteInvalidStudyId(command.studyId);
        }
    }
    handle({ studyId, userId, expectedState, isLocal }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.validate({ studyId, userId, expectedState });
                const wishlist = yield this.getWishlist(userId, expectedState);
                wishlist.removeFavourite(studyId);
                const dateRemoved = this.getCurrentDate();
                yield this.wishlistRepository.removeFavourite(wishlist, domain_1.Favourite.create(studyId), dateRemoved);
                yield this.emitFavouriteRemovedEvent(userId, studyId, wishlist.stateHash, dateRemoved, isLocal);
                return {
                    resultingState: wishlist.stateHash
                };
            }
            catch (error) {
                if (error instanceof domain_1.FavouriteNotFound) {
                    return { resultingState: expectedState };
                }
                throw error;
            }
        });
    }
    emitFavouriteRemovedEvent(userId, studyId, stateHash, dateRemoved, isLocal) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.eventEmitter.emit(domain_1.FavouriteRemoved.EventType, domain_1.FavouriteRemoved.create(userId, studyId, stateHash, dateRemoved, isLocal));
        });
    }
}
exports.DefaultRemoveFromWishlistCommandHandler = DefaultRemoveFromWishlistCommandHandler;
